<div *ngIf="isCountWidget()">
  <count-widget [(model)]="model" [showSelect]="showSelect"></count-widget>
</div>